var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useDispatch } from "react-redux";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSCheckbox } from "@here/hds-react-components/Checkbox";
import { HDSNotification } from "@here/hds-react-components/Notification";
import { ConfirmDailog } from "../../../../../generic-components";
import { ANNOTATION_MODAL_BUTTON, ANNOTATION_REQUEST_UPDATE_MODAL, } from "../../../constants";
import { listOfInfoBubble } from "../../../helper";
import { DropzoneBody } from "../../DropzoneBody/dropzone-body";
import { commonDivStyles, FLOOR_PLANS_DESCRIPTION_PLACEHOLDER, SUBMIT_DIALOG_NOTIFICATION_TEXT, } from "../constant";
import { setDiscardAllAnnotations } from "../../../../../store/reducers/jsMapSlice";
import { DiscardDailog } from "./DiscardDailog";
import "../style.scss";
export var AnnotationWithFloorPlans = function (props) {
    var callbacks = props.callbacks, options = props.options;
    var showModal = options.showModal;
    var handleModal = callbacks.handleModal, handleOnSubmit = callbacks.handleOnSubmit, setShowModal = callbacks.setShowModal;
    var _a = useState(false), discardSubmit = _a[0], setDiscardSubmit = _a[1];
    var _b = useState(false), error = _b[0], setError = _b[1];
    var _c = useState([]), files = _c[0], setFiles = _c[1];
    var _d = useState(""), dropZoneDes = _d[0], setDropZoneDes = _d[1];
    var _e = useState(false), showDropzone = _e[0], setShowDropzone = _e[1];
    var _f = useState(false), checked = _f[0], setChecked = _f[1];
    var dispatch = useDispatch();
    var handleCheckBox = function (e) {
        setShowDropzone(e.checked);
        setChecked(e.checked);
        setFiles([]);
        setError(false);
    };
    var onAttachmentDesChange = function (val) {
        setDropZoneDes(val);
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var annotateWithFloorPlans, isSubmitSuccess, enableDropZone;
        return __generator(this, function (_a) {
            annotateWithFloorPlans = {
                description: dropZoneDes,
                files: files,
            };
            isSubmitSuccess = handleOnSubmit(annotateWithFloorPlans);
            enableDropZone = true;
            if (isSubmitSuccess) {
                enableDropZone = false;
            }
            setShowDropzone(enableDropZone);
            setShowModal(false);
            return [2 /*return*/];
        });
    }); };
    var handleCancel = function () {
        setDiscardSubmit(false);
        handleModal(true);
        onAttachmentDesChange(dropZoneDes);
    };
    var handleDiscardChange = function () {
        setDiscardSubmit(false);
        dispatch(setDiscardAllAnnotations(true));
        setChecked(false);
        setShowDropzone(false);
        setDropZoneDes("");
    };
    var handleDropZoneCancel = function () {
        handleModal(false);
        setShowDropzone(false);
        setChecked(false);
        setDropZoneDes("");
    };
    var handleDropZoneDiscard = function () {
        handleModal(false);
        setDiscardSubmit(true);
    };
    var disableSubmit = showDropzone && (files.length === 0 || error);
    return (_jsxs(_Fragment, { children: [showModal && (_jsx(ConfirmDailog, { hideCloseBtn: false, onClose: handleDropZoneCancel, header: ANNOTATION_REQUEST_UPDATE_MODAL.HEADER, footer: _jsxs("div", __assign({ style: __assign({}, commonDivStyles) }, { children: [_jsx(HDSButton, __assign({ variant: "secondary", size: "small", onClick: handleDropZoneDiscard }, { children: _jsx("div", { children: ANNOTATION_MODAL_BUTTON.DISCARD }) })), _jsx("div", __assign({ onClick: onSubmit }, { children: _jsx(HDSButton, __assign({ variant: "primary", size: "small", disabled: disableSubmit }, { children: ANNOTATION_MODAL_BUTTON.SUBMIT })) }))] })), renderBody: function () { return (_jsxs(_Fragment, { children: [_jsx("p", { children: "".concat(ANNOTATION_REQUEST_UPDATE_MODAL.MESSAGE_TITLE_1, " ").concat(listOfInfoBubble.length, " ").concat(ANNOTATION_REQUEST_UPDATE_MODAL.MESSAGE_TITLE_2) }), _jsx(HDSCheckbox, __assign({ style: { paddingTop: "30px", paddingBottom: "30px" }, onCheck: handleCheckBox, checked: checked }, { children: ANNOTATION_REQUEST_UPDATE_MODAL.MESSAGE })), showDropzone && (_jsx(DropzoneBody, { files: files, setFiles: setFiles, error: error, setError: setError, onDropZoneDesChange: onAttachmentDesChange, descriptionPlaceholder: FLOOR_PLANS_DESCRIPTION_PLACEHOLDER, storedDescription: dropZoneDes })), _jsx("div", { children: _jsx(HDSNotification, { inline: true, "hide-close": true, status: "warning", iconStyle: "outline", timeout: 0, variant: "solid", headline: SUBMIT_DIALOG_NOTIFICATION_TEXT }) })] })); } })), discardSubmit && (_jsx(DiscardDailog, { handleClose: handleCancel, handleDiscardChange: handleDiscardChange, handleCancel: handleCancel }))] }));
};
